import React from "react"

import cellStyles from './cell_styles.module.scss'

const ColumnHeaderGroup = ({ displayName, columnSpan }) => {


    return (

        <th colSpan={columnSpan}>
            <div className={cellStyles.column_header_group_div}>
                {displayName}
            </div>    
        </th>

    )

}

export default ColumnHeaderGroup